import React from "react";
import { Link } from "react-router-dom";
import { FiMapPin } from "react-icons/fi";

// react-icons' IconType returns ReactNode, which React 19's JSX typing
// won't accept as a component; cast once here rather than at each call site.
const MapPinIcon = FiMapPin as unknown as React.FC<{ size?: number; color?: string }>;

const Navbar: React.FC = () => {
  return (
    <nav
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 32px",
        background: "rgba(255,255,255,0.7)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(15,23,42,0.06)",
      }}
    >
      {/* Left: Logo + Home */}
      <Link
        to="/"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          textDecoration: "none",
        }}
      >
        <MapPinIcon size={19} color="#6366f1" />
        <span
          style={{
            fontWeight: 700,
            fontSize: "17px",
            color: "#171616",
            letterSpacing: "-0.2px",
          }}
        >
          Mark's Travel Memories
        </span>
      </Link>

      <Link
        to="/"
        style={{
          textDecoration: "none",
          color: "#334155",
          fontSize: "14px",
          fontWeight: 600,
          padding: "6px 16px",
          borderRadius: "999px",
          background: "#f1f5f9",
          transition: "background 0.15s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#e2e8f0")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "#f1f5f9")}
      >
        Home
      </Link>
    </nav>
  );
};

export default Navbar;
